module.exports = __webpack_public_path__ + "img/emptycart2020.7408ab60.jpg";